var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C19.3989 0 25 5.60107 25 12.5C25 19.3989 19.3989 25 12.5 25C5.60107 25 0 19.3989 0 12.5C0 5.60107 5.60107 0 12.5 0ZM19.9861 8.73916C19.8064 8.06684 19.277 7.5375 18.6047 7.35781C17.3861 7.03125 12.5 7.03125 12.5 7.03125C12.5 7.03125 7.61392 7.03125 6.39526 7.35781C5.72315 7.5375 5.1936 8.06684 5.01392 8.73916C4.6875 9.95767 4.6875 12.5001 4.6875 12.5001C4.6875 12.5001 4.6875 15.0424 5.01392 16.2608C5.1936 16.9332 5.72315 17.4627 6.39526 17.6423C7.61392 17.9688 12.5 17.9688 12.5 17.9688C12.5 17.9688 17.3861 17.9688 18.6047 17.6423C19.277 17.4627 19.8064 16.9332 19.9861 16.2608C20.3125 15.0424 20.3125 12.5001 20.3125 12.5001C20.3125 12.5001 20.3125 9.95767 19.9861 8.73916ZM10.9375 14.8439V10.1563L14.9969 12.5001L10.9375 14.8439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.caa1185f.svg";
export { ForwardRef as ReactComponent };